/**
 * TIER 2 Item 2.5 — Scroll reveal + quick-add wiring
 * - Adds `.is-visible` to `.u-reveal` elements when they enter the viewport
 * - Sets `--stagger-index` per element so staggered grids animate in sequence
 * - Wires up `.product-card__quick-add` (single-variant AJAX add-to-cart)
 * Honors `prefers-reduced-motion` by skipping animation and showing content immediately.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var nodes = document.querySelectorAll('.u-reveal');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var staggerGroups = {};
    nodes.forEach(function (el) {
      if (!el.hasAttribute('data-stagger')) return;
      var group = el.getAttribute('data-stagger-group') || 'default';
      staggerGroups[group] = staggerGroups[group] || 0;
      var index = staggerGroups[group] % 6;
      el.style.setProperty('--stagger-index', String(index));
      staggerGroups[group] += 1;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -80px 0px' }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initQuickAdd() {
    var buttons = document.querySelectorAll('.product-card__quick-add[data-variant-id]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        var cartDrawer = document.querySelector('cart-drawer');
        var body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        // Request the cart-drawer sections so we can refresh + open the drawer after adding
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map(function (s) { return s.id; })
              .join(',')
          );
          body.append('sections_url', window.location.pathname);
        }

        fetch(
          (window.routes && window.routes.cart_add_url) || '/cart/add.js',
          {
            method: 'POST',
            body: body,
            headers: { Accept: 'application/javascript' },
            credentials: 'same-origin',
          }
        )
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function (response) {
            btn.classList.add('is-added');
            btn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            // Open the cart drawer (refreshed with the new item) so the cart is reachable immediately
            if (cartDrawer && response && response.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = originalLabel;
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
            var url = btn.getAttribute('data-product-url');
            if (url) window.location.href = url;
          });
      });
    });
  }

  function init() {
    initReveal();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
